import type { RootState } from '~/store';

export const searchResultSelector = (state: RootState) => state.searchResult;
export const searchResultIsFetchedBeforeSelector = (state: RootState) => !!state.searchResult.isFetchedBefore;
